import { ProfileName } from '@constants/integrations';
import {
    YelpIcon,
    FacebookIcon,
    GoogleIcon,
    TrustpilotIcon,
    TripAdvisorIcon,
    BookingIcon,
    IFoodIcon,
    TheForkIcon,
    DeliverooIcon,
    HotelsIcon,
    ExpediaIcon,
    HealthgradesIcon,
    ZocdocIcon,
    RateMDsIcon,
    BingIcon,
    NavmiiIcon,
    AlexaIcon,
    UberIcon,
    WazeIcon,
    FoursquareIcon,
    TomTomIcon,
    HEREIcon,
} from 'assets/images/integrations';

export const getIntegrationIcon = type => {
    switch (type) {
        case ProfileName.Yelp:
            return <YelpIcon />;
        case ProfileName.Facebook:
        case ProfileName.FacebookOfficial:
            return <FacebookIcon />;
        case ProfileName.Google:
        case ProfileName.GoogleOfficial:
            return <GoogleIcon />;
        case ProfileName.Trustpilot:
            return <TrustpilotIcon />;
        case ProfileName.TripAdvisor:
            return <TripAdvisorIcon />;
        case ProfileName['Booking.com']:
            return <BookingIcon />;
        case ProfileName.TheFork:
            return <TheForkIcon />;
        case ProfileName.Deliveroo:
            return <DeliverooIcon />;
        case ProfileName.iFood:
            return <IFoodIcon />;
        case ProfileName['Hotels.com']:
            return <HotelsIcon />;
        case ProfileName.Expedia:
            return <ExpediaIcon />;
        case ProfileName.Healthgrades:
            return <HealthgradesIcon />;
        case ProfileName.Zocdoc:
            return <ZocdocIcon />;
        case ProfileName.RateMDs:
            return <RateMDsIcon />;
        case ProfileName.Bing:
            return <BingIcon />;
        case ProfileName.Navmii:
            return <NavmiiIcon />;
        case ProfileName.Alexa:
            return <AlexaIcon />;
        case ProfileName.Uber:
            return <UberIcon />;
        case ProfileName.Waze:
            return <WazeIcon />;
        case ProfileName.Foursquare:
            return <FoursquareIcon />;
        case ProfileName.TomTom:
            return <TomTomIcon />;
        case ProfileName.HERE:
            return <HEREIcon />;
        default:
            return null;
    }
};
